import React from 'react';
import { connect } from 'react-redux';
import { Table } from 'semantic-ui-react';
import {
  columnConditions,
  columnLocation,
  columnNameReference,
  columnRequested,
  columnSelect,
  columnStatus,
  columnTools,
} from '@/constants/fields';
import TableWrapper from '@/components/table/TableWrapper';
import WorkspacesTableHeader from '@/workspaces/components/WorkspacesTableHeader';
import WorkspacesTableRows from '@/workspaces/components/WorkspacesTableRows';
import WorkspaceHubsDropdown from '@/workspaces/components/WorkspaceHubsDropdown';
import RequestWorkspacesContainer, {
  mapStateToProps,
  mapDispatchToProps,
} from './RequestWorkspacesContainer';

const buildColumns = (hasConditions) => {
  const columns = [columnSelect, columnNameReference, columnLocation,
    columnRequested, columnTools, columnStatus];

  if (hasConditions) {
    columns.push(columnConditions);
  }

  return columns;
};

const RequestWorkspacesTable = ({
  category,
  code,
  fetchLocations,
  fetchWorkspaces,
  hasConditions,
  location,
  locations,
  locationsReadStatus,
  onCheckBoxClick,
  readErrors,
  readStatus,
  workspaces,
}) => {
  const columns = buildColumns(hasConditions);
  return (
    <RequestWorkspacesContainer
      category={category}
      code={code}
      fetchLocations={fetchLocations}
      readStatus={locationsReadStatus}
    >
      <TableWrapper sticky celled className="aridhia-workspaces-table" columns={columns} selectable>
        <WorkspacesTableHeader
          columns={columns}
          headerId="access.destination.workspace"
          readErrors={readErrors}
          readStatus={[readStatus, locationsReadStatus]}
          workspaces={workspaces}
        >
          {locations.length > 1 && (
            <div className="aridhia-table-filter">
              <WorkspaceHubsDropdown
                locations={locations}
                readStatus={readStatus}
                location={location}
                onChange={(value) => fetchWorkspaces(category, code, value)}
              />
            </div>
          )}
        </WorkspacesTableHeader>
        <Table.Body>
          <WorkspacesTableRows
            items={workspaces}
            columns={columns}
            onCheckBoxClick={(value) => onCheckBoxClick(category, code, value)}
            selectable
          />
        </Table.Body>
      </TableWrapper>
    </RequestWorkspacesContainer>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(RequestWorkspacesTable);
